import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { Link } from "react-router-dom";
import VideoSlider from "./VideoSlider";
import VideoYTShortsSlider from "./VideoYTShortsSlider";

function HydrotracePage() {
  // const raindrops = Array.from({ length: 200 });
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // VIdeo styles
  //const videoRefs = useRef([]);

  // const handlePlay = (index) => {
  //   videoRefs.current.forEach((video, i) => {
  //     if (video && i !== index) {
  //       video.pause();
  //     }
  //   });
  // };

  // const videos = [
  //   { id: 1, src: "../videos/First-India-News.mp4" },
  //   { id: 2, src: "../videos/Rajasthan-Patrika.mp4" },

  // ];
  return (
    <div>
      <div className="inner-new-section-1 hydrotrace-bg-1 ">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500 padding-bottom-2">
            <h1 className="white-color" data-aos="fade-up">
              HydroTRACE<sup>™</sup> – Atmospheric
              <br />
              Intelligence & Water Resilience for
              <br />a Climate-Secure Future
            </h1>
            <p data-aos="zoom-in">
              Transform water futures with an AI-powered platform for rainfall
              enhancement, lake and reservoir management, groundwater analytics,
              and sustainable water governance.
            </p>
            <div className="text-left" data-aos="fade-down">
              <Link
                to="/company/contact#Book-Meeting"
                className="button-1 green-bg"
              >
                Request a Pilot
              </Link>
              <Link to="/company/contact#Book-Meeting" className="button-1">
                Partner With Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 hydrotrace-bg-2">
        <div className="wrapper height-inherit">
          <div className="top-sec-1 text-right">
            <div className="our-vision-wrap float-right-1">
              <div className="d-d"></div>
            </div>
          </div>

          <div className="bottom-sec-1 padding-bottom-2">
            <h2 className="white-color" data-aos="fade-down">
              Rain with Purpose. Water with Precision.
            </h2>
            <p data-aos="fade-up">
              “In a climate-fragile world, HydroTRACE turns clouds into
              controlled infrastructure and water into equity.”
            </p>
            <p data-aos="fade-up">
              HydroTRACE™ is a 360° atmospheric intelligence system built for
              climate-stressed states and cities. It unites AI-powered cloud
              diagnostics, micro-drone seeding, groundwater and reservoir
              analytics, and emergency drought response into a unified
              climate-water resilience platform.
            </p>
          </div>
        </div>
      </div>
      <div className="watch-HydroTRACE-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="text-center brown-color" data-aos="fade-up">
              Watch HydroTRACE in Action
            </h2>
          </div>
          <VideoSlider />
          <br />
          <VideoYTShortsSlider />
          {/* <div className="videos-sec-1">
            {videos.map((video, index) => (
              <div className="vs-1">
                <video
                  key={video.id}
                  ref={(el) => (videoRefs.current[index] = el)}
                  src={video.src}
                  controls
                  onPlay={() => handlePlay(index)}
                />
              </div>
            ))}
          </div> */}
        </div>
      </div>

      <div className="inner-new-section-1 accelalert-bg-3">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="text-center brown-color" data-aos="fade-up">
              Intelligent Cloud Seeding & Rain Activation
            </h2>
            <p>
              Real-time cloud profiling using ground sensors and satellite feeds
              AI models for seedability detection and atmospheric lift
              prediction Drone-activated cloud seeding with NaCl, AgI, or CaCl₂
              agents Full MRV telemetry with environmental safeguards
              Post-seeding validation via on-ground and remote sensors
            </p>
          </div>

          <div className="Core-Capabilities-wrap">
            <h3 className="text-center brown-color hydrotrace-heading ">
              Outcomes
            </h3>
            <img
              src={assets.outcomes_img}
              alt="GlobalStandards"
              className="w-100"
              data-aos="zoom-in"
            />
          </div>
        </div>
      </div>

      <div className="our-philosophy-bg-1 hydrotrace-bg-3">
        <div className="wrapper height-inherit">
          <div class="flagship-heading" data-aos="zoom-in">
            <h2>
              From Sensors to Sky: Precision Rain When & Where It’s Needed
            </h2>
            <p>
              HydroTRACE™ links ground-based soil sensors with AI-guided cloud
              seeding drones. When a field's moisture drops below optimal
              levels, the system detects the need — say, for 2mm of rainfall —
              and automatically triggers aerial micro-precipitation. It’s
              rainfall-as-a-service, optimized by data and powered by the sky..
            </p>
          </div>
        </div>
      </div>

      <div className="bg-section-1 green-bg-2">
        <div className="wrapper">
          <h2 data-aos="zoom-in" className="text-center green-color">
            Water Intelligence Across 7 Fronts
          </h2>
          <div className="pledge-wrap hydro-ul">
            <div className="pledge-line"></div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_1} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>1. Drought Resilience & Emergency Rainfall</h4>
                <p>
                  <ul>
                    <li>Hyperlocal rain activation protocols</li>
                    <li>Geo-fenced UAV missions in climate-stressed zones</li>
                    <li>Real-time AI-based rain pattern simulation</li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_2} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>2. Groundwater Recharge & Balance Analytics</h4>
                <p>
                  <ul>
                    <li>
                      AI mapping of aquifer levels and over-extraction zones
                    </li>
                    <li>Simulation of recharge from induced rainfall events</li>
                    <li>Risk mapping for future depletion hotspots</li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_3} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>3. Surface Water & Catchment Monitoring</h4>
                <p>
                  <ul>
                    <li>
                      Satellite and drone-based analytics of reservoirs, tanks,
                      lakes
                    </li>
                    <li>
                      Water level tracking, evaporation trends, siltation models
                    </li>
                    <li>
                      Support for lake rejuvenation and smart bund construction
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_4} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>4. GeoTextile-Based Reservoir & Lake Sustainability</h4>
                <p>
                  <ul>
                    <li>
                      Bio-friendly geotextile coverings for evaporation control
                    </li>
                    <li>
                      Structural reinforcement of bunds and lake perimeters
                    </li>
                    <li>
                      Integrated modeling for inflow/outflow and percolation
                      efficiency
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_5} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>5. Urban Water Governance & Smart Drainage</h4>
                <p>
                  <ul>
                    <li>
                      Integration with smart city infrastructure and weather
                      stations
                    </li>
                    <li>Rain-linked drainage load simulation and mitigation</li>
                    <li>
                      Heat island mapping + rain scheduling for city cooling
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_6} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>6. Climate-Linked Agri-Water Advisory</h4>
                <p>
                  <ul>
                    <li>
                      Agro-ecological rainfall prediction and zone targeting
                    </li>
                    <li>Rainfall planning for crop stages</li>
                    <li>Precision water allocation for dryland farming</li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.intelligence_7} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>7. Climate Finance & Carbon Revenue</h4>
                <p>
                  <ul>
                    <li>
                      Quantification of CO₂e offset from enhanced rainfall &
                      recharge
                    </li>
                    <li>
                      Carbon monetization model tied to atmospheric
                      interventions
                    </li>
                    <li>
                      Public-private MRV dashboards for carbon-backed funding
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div>
        <div className="drone-rain-container">
          <div className="cloud-drone-wrapper">
            <div className="cloud">
              <img src={assets.cloudImage} alt="Cloud" className="cloud-img" />
              <img src={assets.droneImage} alt="Drone" className="drone-img" />
              <div className="rain-container">
                {raindrops.map((_, index) => {
                  const left = Math.random() * 100;
                  const delay = Math.random() * 2;
                  const duration = 0.5 + Math.random();
                  return (
                    <div
                      key={index}
                      className="raindrop"
                      style={{
                        left: `${left}%`,
                        animationDelay: `${delay + 2}s`,
                        animationDuration: `${duration}s`,
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>

          <div className="land"></div>
        </div>
      </div> */}

      <div className="inner-new-section-1 hydrotrace-bg-7">
        <div className="wrapper height-inherit">
          <div className="bioforge-align-right ">
            <div className="bioforge-section-2-1">
              <h2 className="white-color">HydroTRACE Core Advantages</h2>
              <div className="building-list ">
                <ul>
                  <li>
                    Multi-tier architecture: satellite, drone, IoT & AI fusion
                  </li>
                  <li>Pre-seeding and post-seeding decision dashboard</li>
                  <li>Drone fleets + mobile sensor stations</li>
                  <li>
                    Zero CapEx model for governments and organizations
                    (Climate-as-a-Service)
                  </li>
                  <li>Cloud-in-the-loop with NDMA, IMD & Urban AI feeds</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ecosystem-bg hydrotrace-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="white-color">Deployment Models</h2>
            <p>
              We believe climate cannot be solved in silos. That’s why we
              actively co-create with:
            </p>
          </div>
          <img src={assets.aproch} alt="VisionImpactImg" data-aos="zoom-in" />
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-3 height-inherit-2">
        <div className="wrapper">
          <h2 className="text-center">Measurable Impact Metrics</h2>

          <div className="ethos-wrap">
            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.mim_1} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>mm of rainfall induced (Geo-fenced)</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.mim_2} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>% drop in lake/reservoir evaporation</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.mim_3} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>Groundwater recharge increase (via hydro-modeling)</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.mim_4} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>
                  Reservoir health improvement index (cleaning, siltation,
                  recharge)
                </p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.mim_5} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>AI accuracy in rainfall pattern predictions</p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.mim_6} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <p>Carbon offset potential (CO₂e) per district/state</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 hydrotrace-bg-6">
        <div className="wrapper">
          <h2 className="text-center brown-color ">
            Measurable Impact Metrics
          </h2>
          <div className="mrv-three-col-main ">
            <div className="mrv-three-col-1">
              <img src={assets.mrvimg1} alt="mrvimg1" />
              <b>Verifiable rainfall-induced water credits</b>
            </div>
            <div className="mrv-three-col-1">
              <img src={assets.mrvimg2} alt="mrvimg1" />
              <b>Dashboard for city/state climate fund use</b>
            </div>
            <div className="mrv-three-col-1">
              <img src={assets.mrvimg3} alt="mrvimg1" />
              <b>
                Linked with SDG 6 (Water), SDG 13 (Climate), SDG 11 (Sustainable
                Cities)
              </b>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 hydrotrace-bg-5">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 padding-bottom-2">
            <h2 className="white-color" data-aos="fade-down">
              Built by Climate Engineers
            </h2>
            <p data-aos="fade-up">
              HydroTRACE is designed by a world-class team of meteorologists,
              remote sensing specialists, and atmospheric AI engineers,
              combining global cloud science with local weather intelligence.
            </p>
            <p data-aos="fade-up">
              “We don’t just predict rain. We generate it—scientifically,
              safely, and strategically.”
            </p>
          </div>
        </div>
      </div>
      <div className="about-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="brown-color">
              Ready to Make it Rain with Intelligence?
            </h2>
            <p>
              HydroTRACE is redefining what’s possible in water resilience, rain
              planning, and lake sustainability.
            </p>

            <Link
              to="/company/contact"
              className="button-1"
              onClick={scrollToTop}
            >
              Book a Rain Intelligence Demo
            </Link>
            <Link
              to="/company/contact"
              className="button-1"
              onClick={scrollToTop}
            >
              Deploy Water Resilience Module
            </Link>
          </div>
        </div>
      </div>
      {/* <div className="section-1" style={sectionStyle}>
        <img src={assets.banner1} alt="" data-aos="fade-up" />
      </div> */}
    </div>
  );
}

export default HydrotracePage;
